var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"freezingScreening",staticClass:"dialog-container"},[_c('div',{staticClass:"dialog",staticStyle:{"max-height":"720px","transform":"translate(0, -360px)"}},[_c('button',{staticClass:"btn-cancel fright",attrs:{"type":"button","title":"Close"},on:{"click":function($event){return _vm.doCancel()}}},[_vm._v(" Close ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }